// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function print(key: string, data: any, options?: any) {
  localStorage.setItem("printTarget", key);
  localStorage.setItem("printData", JSON.stringify(data));
  localStorage.setItem("printOptions", JSON.stringify(options || {}));
  window.open("/print");
}
